export default __webpack_public_path__ + "static/media/mastercard.3a55b547.svg";